import { intlConstants } from '../../constants/intl';
import { Cookies } from '../../utils/utils';

const setCookieLang = store => next => action => {
  if (action.type === intlConstants.SET_LOCALE) {
    Cookies.set('offerrum_lang', action.locale);
  }
  return next(action);
};

export default setCookieLang;
